<template>
  <div class="basket-product-addons grid gap-1">
    <div 
      v-for="addon in addons" 
      :key="addon.name"
      class="basket-product-addons__item flex gap-3 justify-between"
    >
      <div class="basket-product-addons__name text-sm">
        {{ addon.name }}
      </div>
      <div class="basket-product-addons__price text-sm">
        +{{ addon.price }} ₽
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface AddonDisplay {
  name: string
  price: string
}

interface Props {
  addons: AddonDisplay[]
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.basket-product-addons {
  &__item {
    @apply flex items-center justify-between;
  }
  
  &__name {
    @apply text-sm text-gray-700 dark:text-gray-300;
  }
  
  &__price {
    @apply text-sm font-medium text-green-600 dark:text-green-400;
  }
}
</style>